import React, { useEffect, useState, lazy, Suspense } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  getTermsAndConditionAPI,
  updateTermsAndConditionAPI,
} from "../../API/Terms_And_Conditions/Terms_And_Condition";
import toast from "react-hot-toast";
import ButtonLoader from "../../components/button/ButtonLoader";

const Wrapper = lazy(() => import("../../components/wrapper/Wrapper"));
const Button = lazy(() => import("../../components/button/Button"));
const Heading = lazy(() => import("../../components/text/Heading"));

const TermsAndConditions = () => {
  const [termsAndConditionsData, setTermsAndConditionsData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [termsAndConditionsValue, setTermsAndConditionsValue] = useState(null);

  // Fetching the data from API
  useEffect(() => {
    (async function handleGetAPI() {
      try {
        setIsLoading(true);
        const res = await getTermsAndConditionAPI();
        setTermsAndConditionsData(res.data.data);
        setTermsAndConditionsValue(res.data.data.termAndCondition);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        console.error("Error fetching terms and conditions:", err);
      }
    })();
  }, []);

  const EditTermConditionContext = (e) => {
    setTermsAndConditionsValue(e);
  };

  const handleSave = async () => {
    try {
      setSaveLoading(true);
      const editedTermAndCondition = await updateTermsAndConditionAPI({
        termAndCondition: termsAndConditionsValue,
      });
      console.log(editedTermAndCondition.data.data);
      setTermsAndConditionsData(editedTermAndCondition.data.data);
      toast.success("saved");
      setSaveLoading(false);
    } catch (error) {
      console.error("Error saving terms and conditions:", error);
      toast.error("failed to save");
      setSaveLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="py-10 w-full flex justify-center items-center">
        <ButtonLoader />
      </div>
    );
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Wrapper>
        <div className="flex justify-between items-end">
          <Heading heading={"Terms and Conditions"} />
          <div className="gap-3 flex justify-center items-center">
            <Button
              text={"Save"}
              disabled={saveLoading}
              onClick={handleSave}
              isLoading={saveLoading}
            />
          </div>
        </div>

        <div className="mt-2">
          <p className="text-sm text-gray-500 font-medium">
            {new Date(termsAndConditionsData.updatedAt).toLocaleString()}
          </p>
        </div>

        <div className="mt-1">
          <div className="bg-white mt-3">
            <ReactQuill
              className=""
              value={termsAndConditionsValue}
              onChange={EditTermConditionContext}
            />
          </div>
        </div>
      </Wrapper>
    </Suspense>
  );
};

export default TermsAndConditions;
